export class FacetFilter {
    text: string;

    constructor() {
        this.text = '';
    }
}